import React from 'react';

import '../styles/signup.css';
import { translate } from 'react-polyglot';

const SignupForm = ({ source_id, t }) =>
  <form
    action="https://accounts.livechatinc.com/signup/credentials/"
    className="signup"
    autoComplete="off"
  >
    <a href="https://www.livechatinc.com/signup/?utm_source=quality_page&utm_medium=referral&utm_campaign=footer-form">
      {t('quality_create_your_own_quality_page')}
    </a>
    <input type="hidden" name="source_id" value={source_id} />
    <input type="hidden" name="source_type" value="ght" />
    <input type="hidden" name="source_url" value={window.location.href} />
    <input
      type="email"
      name="email"
      required
      placeholder={t('quality_your_business_email')}
    />
    <button type="submit">
      {t('quality_sign_up_free')}
    </button>
  </form>;

export default translate()(SignupForm);



// WEBPACK FOOTER //
// ./src/components/SignupForm.js